import { MEMBERSHIP_STATUS } from 'constants/subscriptions'

export enum VARIANTS {
  GRADIENT_BLUE = 'bg-blue-gradient text-white',
  GRADIENT_GREEN = 'bg-green-gradient text-[#08741A]',
  GRADIENT_RED = 'bg-red-gradient text-[#692A1B]',
  GREEN = 'bg-green-100 text-[#08741A]',
  SILVER = 'bg-gray-300 text-gray-900',
  YELLOW = 'bg-yellow-100 text-[#726108]',
  RED = 'bg-red-100 text-[#692A1B]'
}

interface BadgeProps {
  children: JSX.Element | JSX.Element[]
  variant?: keyof typeof VARIANTS
  className?: string
  id?: string
}

const Badge = ({
  children,
  variant = 'GRADIENT_BLUE',
  className = '',
  id = 'badge'
}: BadgeProps) => (
  <span
    id={id}
    className={`inline-flex items-center transition-all duration-200 ease-in-out gap-1 py-1 px-2 text-2xs font-bold rounded-lg ${VARIANTS[variant]} ${className}`}
  >
    {children}
  </span>
)

export default Badge

export const MembershipBadge = ({ status, className = '' }) => {
  if (
    status === MEMBERSHIP_STATUS.ACTIVE ||
    status === MEMBERSHIP_STATUS.DELAYED
  ) {
    return (
      <Badge variant='GRADIENT_GREEN' className={className}>
        <div className='text-center w-full'>Activa</div>
      </Badge>
    )
  }

  if (status === MEMBERSHIP_STATUS.SUSPENDED) {
    return (
      <Badge variant='GRADIENT_RED' className={className}>
        <div className='text-center w-full'>Suspendida</div>
      </Badge>
    )
  }

  return null
}
